<template>
  <div class="uk-card card uk-card-default uk-card-hover">
    <div class="uk-card-media-top">
      <img alt="" uk-img width="322" height="233" :data-src="blog.blog_img" />
    </div>
    <div class="uk-card-body card-body">
      <h3 class="title" :class="{'text-center': blog.title.length <= 12, 'min-height' : isInIndexPage === true}">{{ blog.title }}</h3>
      <p class="description">
        {{ blog.description }}
      </p>
      <div class="footer">
        <div class="read-more"><a href="">閱讀更多</a></div>
        <div class="category">
          <span>{{ categoryStr }}</span>
        </div>
      </div>
    </div>
    <a :href=blogUrl style="display:block;position:absolute; top:0;height:100%; width:100%; text-decoration:none"></a>
  </div>
</template>
<script>
export default {
  name: "Blog",
  props: ["blog", "isInIndexPage"],
  computed: {
    blogUrl() {
      return "/blog/" + this.blog.slug_name;
    },
    categoryStr() {
      if (this.blog.category === 'SEEDS') {
        return '人物專訪'
      }else if (this.blog.category === 'FICTION') {
        return '短篇小說'
      }else if (this.blog.category === 'FEEDBACK') {
        return '學員故事'
      }else if(this.blog.category === 'INFORMATION') {
        return '知識文章'
      }else {
        return ''
      }
    },
  },
  methods: {
  },
};
</script>
<style lang="scss">
.card {
  border-radius: 10px;
  text-align: left;
  background-color: #ffffff;
  position:relative;
  img {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    width: 100%;
  }
  .card-body {
    padding: 23px 23px 39px;
    .title {
      font-family:  'Heebo', 'Noto Sans TC', sans-serif;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.45;
      letter-spacing: 1px;
      text-align: left;
      color: #585858;
      &.text-center {
          text-align: center;
        }
      &.min-height {
        min-height: 4em*1.45;
      }
    }
    .description {
      font-family:  'Heebo', 'Noto Sans TC', sans-serif;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.69;
      letter-spacing: 0.8px;
      text-align: justify;
      color: #a5a5a5;
      overflow: hidden;
      min-height: calc(1.72em * 4);
      max-height: calc(1.72em * 4);
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width:100%;
      .read-more {
        display: inline-block;
        font-family:  'Heebo', 'Noto Sans TC', sans-serif;
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: 0.32px;
        text-align: left;
        padding-left: 23px;
        padding-bottom: 23px;
        width: 50%;
        a {
          &:link,
          &:active,
          &:visited {
            color: #003232;
          }
          &:hover {
            color: #003232;
            text-decoration: underline;
          }
        }
      }
      .category {
        display: inline-block;
        font-family:  'Heebo', 'Noto Sans TC', sans-serif;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: right;
        color: #106772;
        width: 50%;
        padding-right: 23px;
        padding-bottom: 23px;
      }
    }
    @media (min-width: 640px) and (max-width: 1119.98px) {
      padding: 30px 30px 48px;
      .title {
        font-family:  'Heebo', 'Noto Sans TC', sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 30px;
        letter-spacing: 1.1px;
        text-align: left;
        color: #585858;
        &.min-height {
          min-height: 90px;
        }
      }
      .description {
        font-family:  'Heebo', 'Noto Sans TC', sans-serif;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 27px;
        letter-spacing: 0.7px;
        text-align: justify;
        color: #b5b5b5;
      }
      .footer {
        .read-more {
          font-family:  'Heebo', 'Noto Sans TC', sans-serif;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: 0.32px;
          text-align: left;
          color: #003232;
          padding-left: 30px;
          padding-bottom: 30px;
        }
        .category {
          font-family:  'Heebo', 'Noto Sans TC', sans-serif;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          text-align: right;
          padding-right: 30px;
          padding-bottom: 30px;
        }
      }
    }
    @media (min-width: 1120px) {
      padding: 30px 30px 48px;
      .title {
        font-family:  'Heebo', 'Noto Sans TC', sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 30px;
        letter-spacing: 1.1px;
        text-align: left;
        color: #585858;
        &.min-height {
          min-height: 90px;
        }
      }
      .description {
        font-family:  'Heebo', 'Noto Sans TC', sans-serif;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 27px;
        letter-spacing: 0.7px;
        text-align: justify;
        color: #b5b5b5;
      }
      .footer {
        .read-more {
          font-family:  'Heebo', 'Noto Sans TC', sans-serif;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: 0.32px;
          text-align: left;
          color: #003232;
          padding-left: 30px;
          padding-bottom: 30px;
        }
        .category {
          font-family:  'Heebo', 'Noto Sans TC', sans-serif;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          text-align: right;
          padding-right: 30px;
          padding-bottom: 30px;
        }
      }
    }
  }
}
</style>